import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import duration from 'dayjs/plugin/duration'
import utc from 'dayjs/plugin/utc'

dayjs.locale('ru')
dayjs.extend(duration)
dayjs.extend(utc)

export const getDateInUtcMode = (date: dayjs.ConfigType) => {
  return dayjs.utc(date)
}

export const formatDate = (date: dayjs.ConfigType) => {
  return `${dayjs(date).format('YYYY-MM-DDTHH:MM:ss')}Z`
}
